import { render, staticRenderFns } from "./StockReport.vue?vue&type=template&id=9586571c&"
import script from "./StockReport.vue?vue&type=script&lang=js&"
export * from "./StockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports